import { useCallback } from "react";

import { useProfile } from "../../authentication/state/profile";

import selectOrganization from "../utils/selectOrganization";

export default function useSelectOrganization() {
	const user = useProfile();

	return useCallback(
		({ id, type } = {}) => {
			if (id && type && user) {
				selectOrganization({ id, type, user });
			}
		},
		[user],
	);
}
